<template>
  <header class="welcome-msg">
    <h2>Welcome to Novasector</h2>
    <p class="sub">Pick a topic — or use the links on the right.</p>
  </header>
  <section class="main-layout blog-home">
    <div class="dflexr-jcsb row1 home-row">
      <section class="main-panel">
        <div v-if="error" class="blog-error">{{ error }}</div>
        <div v-else-if="loading" class="blog-loading">Loading topics…</div>
        <div v-else class="topic-grid">
          <article
            v-for="topic in topics"
            :key="topic.slug"
            class="topic-card"
            @click="goTopic(topic.slug)"
          >
            <h3>{{ topic.title }}</h3>
            <p class="blurb">{{ topic.description }}</p>
            <div class="card-actions" @click.stop>
              <router-link class="card-link" :to="{ name: 'topic', params: { slug: topic.slug } }">
                View posts
              </router-link>
              <router-link
                v-if="topic.link_path"
                class="card-link section"
                :to="topic.link_path"
              >
                Open section
              </router-link>
            </div>
          </article>
        </div>
      </section>

      <aside class="dflexc-jcs link-panel">
        <div class="img-container">
          <router-link class="nav-link" :to="{ name: 'EmpireWargames' }">
            <img src="/Has_A_Role_Logo.png" alt="Empire Wargames — Has A Role logo">
          </router-link>
        </div>

        <div class="img-container">
          <router-link class="nav-link" :to="{ name: 'StarCitizen' }">
            <img
              src="@/assets/images/SC_floating_in_space_small.png"
              alt="Star Citizen"
            >
            <span class="star-citizen-title">Star Citizen</span>
          </router-link>
        </div>

        <div class="img-container text-link-card tao-card">
          <router-link class="nav-link" :to="{ name: 'tao' }">
            <span class="tao-title">Tao Te Ching</span>
          </router-link>
        </div>
      </aside>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { BlogService } from "@/services/blog_service";

const router = useRouter();
const blog = new BlogService();
const topics = ref([]);
const loading = ref(true);
const error = ref("");

function goTopic(slug) {
  router.push({ name: "topic", params: { slug } });
}

onMounted(async () => {
  try {
    const pkg = await blog.getTopics();
    topics.value = pkg.topics || [];
  } catch (e) {
    error.value = "Could not load topics. Is the API running on :4200?";
    console.error(e);
  } finally {
    loading.value = false;
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mainlanding";
@import "@/assets/styles/blog";

.home-row {
  align-items: flex-start;
  gap: 1.25rem;
}

.main-panel {
  flex: 5;
  min-width: 0;
}

.link-panel {
  flex: 0 0 180px;
  max-width: 220px;
}

.text-link-card {
  min-height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid rgba(105, 158, 191, 0.35);
  background: rgba(0, 0, 0, 0.35);

  a {
    display: flex;
    width: 100%;
    height: 100%;
    min-height: 88px;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }
}

.tao-card .tao-title {
  font-size: 1.25em;
  font-weight: 700;
  color: #c9e4ff;
  text-shadow: 0 0 4px rgba(0, 0, 0, 0.8);
}

@media screen and (max-width: 700px) {
  .home-row {
    flex-direction: column;
  }

  .link-panel {
    flex: 1 1 auto;
    max-width: none;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .img-container {
    flex: 1 1 140px;
    max-width: 200px;
  }
}
</style>
